import React from 'react'
import { useState, useContext } from 'react';
import { ApiGetCall, ApiPostCall } from '../JS/Connector';
import { HideLoder, LogInSchoolID, LogInUserID, origin, ShowLoder } from '../JS/Common';
import { useEffect } from 'react';
import AlertsComp from './AlertsComp';
import Popup from './Popup';
import { useSelector } from 'react-redux';
import useConfig from '../Hooks/useConfig';

function TicketStatusDropdown(props) {
    const { organization, adminCallNode } = useConfig();
    const [TicketStatus, setTicketStatus] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [isStatusClosepopup, setIsStatusClosepopup] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [selectedOptionForLoner, setSelectedOptionForLoner] = useState('');
    const [Errormsg1, setErrormsg1] = useState('');
    const [NoteStatusPopUp, setNoteStatusPopUp] = useState(false);
    const [ticketstatusnotes, setTicketStatusNotes] = useState("");
    const [loading, setLoading] = useState(false);
    const StateData = useSelector((state) => state.authData);
    const [ticketStatusCode, SetTicketStatusCode] = useState('');
    useEffect(() => {
        ListOfTicketStatus();
    }, [])

    async function ListOfTicketStatus() {
        if (props.GridFlag == 1) {
            var flag = 1
        } else if (props.GridFlag == 2 || props.GridFlag == 3) {
            var flag = 2
        } else if (props.GridFlag == 5) {
            var flag = 3
        } else if (props.GridFlag == 4) {
            var flag = 4
        } else if (props.GridFlag == 6) {
            var flag = 5
        }
        setLoading(true);
        await ApiGetCall(`/tickets/statuses?flag=${flag}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setTicketStatus(responseRs);
                setLoading(false);
            }
        });
    };



    function handleOptionChange(e) {
        const selectedValue = e.target.value;
        const ticketStatusCode = e.target.selectedOptions[0].dataset.statuscode;
        setSelectedOption(selectedValue);
        SetTicketStatusCode(ticketStatusCode);
        if (selectedValue == "0") return;
        if (LogInSchoolID != 0) {
            if (ticketStatusCode == '2' && props.lonerFlagCount != 0) {
                setIsStatusClosepopup(true);
            } else if (ticketStatusCode == '7' && props.lonerFlagCount != 0) {
                setIsStatusClosepopup(true);
            } else if (ticketStatusCode == '8' && props.lonerFlagCount != 0) {
                setIsStatusClosepopup(true);
            } else if (ticketStatusCode == '18' && props.lonerFlagCount != 0) {
                setIsStatusClosepopup(true);
            }
            else {
                setIsStatusClosepopup(false);
                DropdownStatusCall(selectedValue, ticketStatusCode);
            }
        }

        if (LogInSchoolID == 0 || LogInSchoolID == undefined || LogInSchoolID == '')
            if (['9', '10', '11', '12', '13', '15', '16', '17', '19', '20'].includes(ticketStatusCode)) {
                setNoteStatusPopUp(true);
            } else if (ticketStatusCode !== '2' && [2, 3, 4].includes(props.GridFlag)) {
                DropdownStatusCall(selectedValue, ticketStatusCode);
            } else if (ticketStatusCode === '2' && props.GridFlag === 3) {
                DropdownStatusCall(selectedValue, ticketStatusCode);
            } else if (['1', '3', '2', '7', '8', '18'].includes(ticketStatusCode) && (props.GridFlag === 5 || props.GridFlag === 6)) {
                setNoteStatusPopUp(true);
            }

    }

    async function DropdownStatusCall(selectedValue, ticketStatusCode) {
        if (selectedOptionForLoner == 0 && ticketStatusCode == '2' && props.lonerFlagCount != 0) {
            setErrormsg1('Select atleast one option')
            return
        } else if (selectedOptionForLoner == 0 && ticketStatusCode == '7' && props.lonerFlagCount != 0) {
            setErrormsg1('Select atleast one option')
            return
        } else if (selectedOptionForLoner == 0 && ticketStatusCode == '8' && props.lonerFlagCount != 0) {
            setErrormsg1('Select atleast one option')
            return
        } else if (selectedOptionForLoner == 0 && ticketStatusCode == '18' && props.lonerFlagCount != 0) {
            setErrormsg1('Select atleast one option')
            return
        }

        const issueIDArray = props.selectedIds.map((ticketId) => {
            return { TicketID: ticketId };
        });
        setLoading(true);
        var raw = JSON.stringify({
            userId: LogInUserID,
            issueIds: props.SelectAllFlag == 0 ? issueIDArray : [],
            statusId: selectedValue,
            flag: props.lonerFlagCount != 0 ? 1 : 0,
            closeStatus: selectedOptionForLoner || 0,
            schoolId: LogInSchoolID,
            tabFlag: props.GridFlag,
            selectAllFlag: props.SelectAllFlag,
            searchString: props.GridFlag == 1 ? props?.searchString?.SearchForOpen :
                props.GridFlag == 2 ? props?.searchString?.SearchForClose :
                    props.GridFlag == 3 ? props?.searchString?.SearchForPending :
                        props.GridFlag == 4 ? props?.searchString?.SearchForAll
                            : ''
        });
        await ApiPostCall("/tickets/change-status", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Status Updated Successfully"} />);
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />)
                        if (selectedValue == 2) {
                            setIsStatusClosepopup(false);
                        }
                        if (props.GridFlag == 1) {
                            props.GetGridData(1, null, null, null, false)
                        } else if (props.GridFlag == 2) {
                            props.GetGridData(2, null, null, null, false)
                        } else if (props.GridFlag == 3) {
                            props.GetGridData(3, null, null, null, false)
                        } else if (props.GridFlag == 4) {
                            props.GetGridData(4, null, null, null, false)
                        } else {
                            props.GetGridData(5, null, null, null, false)
                        }
                        props.ClosePopup();
                        props.setSelectedIds([]);
                        props.setSelectAllFlag(0);
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    async function DropdownStatusCallForAdmin(selectedValue) {
        var raw = JSON.stringify({
            userId: LogInUserID,
            ticketIdArray: props.SelectAllFlag == 0 ? props.selectedIds : [],
            statusId: selectedValue,
            note: ticketstatusnotes,
            whoWorkedOnId: StateData?.csvUserID,
            schoolId: props.schoolId,
            selectAllFlag: props.SelectAllFlag,
            tabFlag: props.tabflagforadmin == 1 || props.tabflagforadmin == 2 || props.tabflagforadmin == 3 ? 1 : 2,
            searchString: props.tabflagforadmin == 1 ? props?.TicketsTabs?.SearchForAtVendor :
                props.tabflagforadmin == 2 ? props?.TicketsTabs?.searchForSentOutForRepair :
                    props.tabflagforadmin == 3 ? props?.TicketsTabs?.SearchForOpen :
                        props.tabflagforadmin == 4 ? props?.TicketsTabs?.SearchForRepairFinished :
                            props.tabflagforadmin == 5 ? props?.TicketsTabs?.SearchForRepairBilled :
                                props.tabflagforadmin == 6 ? props?.TicketsTabs?.SearchForClosed
                                    : ''
        });
        await ApiPostCall(`${adminCallNode}/tickets/change-status`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Status Updated Successfully"} />);
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />)
                        setNoteStatusPopUp(false)
                        var batchid = props.selectedbatchid
                        if (batchid == 0) {
                            batchid = null
                        }
                        if (props.tabflagforadmin == 1) {
                            props.GetGridData(null, 1, batchid, null, false)
                        } else if (props.tabflagforadmin == 2) {
                            props.GetGridData(null, 2, batchid, null, false)
                        } else if (props.tabflagforadmin == 3) {
                            props.GetGridData(null, 3, batchid, null, false)
                        } else if (props.tabflagforadmin == 4) {
                            props.GetGridData(null, 4, batchid, null, false)
                        } else if (props.tabflagforadmin == 5) {
                            props.GetGridData(null, 5, batchid, null, false)
                        } else {
                            props.GetGridData(null, 6, batchid, null, false)
                        }

                        props.setSelectedIdsAtVendor1([]);
                        props.setSelectedIdsSentOut1([]);
                        props.setSelectedIdsRepairFinished1([]);
                        props.setSelectedIdsRepairBilled1([]);
                        props.setSelectedIdsOpen1([]);
                        props.setSelectedIdsClosed1([]);

                        props.setSelectedIdsAtVendor([]);
                        props.setSelectedIdsSentOut([]);
                        props.setSelectedIdsRepairFinished([]);
                        props.setSelectedIdsRepairBilled([]);
                        props.setSelectedIdsOpen([]);
                        props.setSelectedIdsClosed([]);

                        props.setSelectAllFlag(0);
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    function handleStatusForClose(flag) {
        if (flag === 'FreeDevice') {
            setSelectedOptionForLoner(2)
        } else if (flag === 'ParmanentDevice') {
            setSelectedOptionForLoner(1)
        } else {
            setSelectedOptionForLoner(0)
        }
    }
    const assignlonerbody = (
        <>
            <div>
                <input className="form-check-input me-2" type="radio" name="CloseStatus" id="FreeDevice" value="FreeDevice"
                    onChange={() => handleStatusForClose('FreeDevice')} /> Give Original Device Back To User?
            </div>
            <div className="col-12">
                <input className="form-check-input me-2" type="radio" name="CloseStatus" id="ParmanentDevice" value="ParmanentDevice"
                    onChange={() => handleStatusForClose('ParmanentDevice')} /> Keep loaner device as a permanent device for {organization?.toLowerCase()}?
            </div>
            {selectedOptionForLoner == 0 ?
                <div className="redText px-5" id='statusMsg'>{Errormsg1}</div>
                : <></>
            }
        </>
    )
    const ticketstatusbody = (
        <div className="p-3">
            <div className="col-12">
                <textarea rows={3} className="form-control" value={ticketstatusnotes} onChange={(e) => setTicketStatusNotes(e.target.value)}></textarea>
                <span>Notes</span>
            </div>
        </div>
    )
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <select onChange={(e) => handleOptionChange(e)} value={selectedOption} >
                <option value="0">Change Ticket Status</option>
                {TicketStatus.map((item, i) => {
                    var returData;
                    returData = (
                        <option className="TicketStatus" statusid={item.id} value={item.id} key={i} data-statuscode={item.ticket_status_code}>{item.status} </option>
                    );
                    return returData;
                })}
            </select>

            <Popup isshow={isStatusClosepopup} size={"md"} title={"Assign a loaner"}
                closePopup={(e) => setIsStatusClosepopup(false)}
                modalBody={assignlonerbody} handleSave={(e) => DropdownStatusCall(selectedOption, ticketStatusCode)} visibleSaveBtn={true} btnText={"Submit"} />

            <Popup isshow={NoteStatusPopUp} size={"md"} title={"Ticket Status Note"}
                closePopup={(e) => { setNoteStatusPopUp(false); setSelectedOption('0') }}
                modalBody={ticketstatusbody} visibleSaveBtn={true} handleSave={(e) => DropdownStatusCallForAdmin(selectedOption)} btnText={"Change Status"} />
        </div >
    )
}

export default TicketStatusDropdown
